import { format, parse, addDays } from 'date-fns'

export default {
  methods: {
    makeLongDate(date) {
      return format(date, 'MMMM Do, YYYY')
    },
    makeShortDate(date) {
      return format(date, 'DD/MM/YYYY')
    },
    makeShortDateAndTime(date) {
      return format(date, 'DD/MM/YYYY h:mmA')
    },
    makeComputerDate(date) {
      return format(date, 'YYYY-MM-DD')
    },
    makeTime(date) {
      return format(date, 'h:mma')
    },
    makeTimeForEntry(date) {
      return format(date, 'HH:mm')
    },
    makeTimeIgnoreZone(date) {
      //console.log(date);
      if (!!date) {
        return format(date, 'h:mma')
        //return format(date.slice(0,-4), "h:mma")
      } else {
        return null
      }
    },
    makeBillingPeriod(date) {
      return format(date, 'YYYY-MM')
    }
  }
}
